// Since woocommerce uses classic editor, adding classnames can be hard for non-tech people.
// Hence we fix them automatically to be bootstrapped.
function handleWoocommerceTables() {
  const tables = document.querySelectorAll('.wc-tabs-wrapper > .wc-tab table');
  if (tables)
    tables.forEach((el) => {
      if (el.classList.length === 0)
        el.classList.add('table', 'table-striped', 'table-bordered');
    });
}

// This is due to the fact that gutenberg tables are inside figure and the class gets applied wrong.
function fixTables() {
  const tables = document.querySelectorAll('.fix-table table');
  if (tables)
    tables.forEach((el) => {
      el.classList.add('table', 'table-borderless');
    });
}

window.addEventListener('DOMContentLoaded', function () {
  // Since there are no good mixins for table styles from bootstrap we have to hack it this way.
  handleWoocommerceTables();
  fixTables();
});
